
import { RulesEngineRuleRunTypeEnum } from "../../common/enums/RulesEngineRuleRunTypeEnum";
import { RulesEngineRuleTypeEnum } from "../../common/enums/RulesEngineTypeEnum";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { DurationOptionEnum } from "../../components/custom-duration-dialog/CustomDurationUtils";

export const keys = {
    all: ["history"],
    lists: () => [
        ...keys.all,
        "list"
    ],
    list: (
        customerID: number,
        groupID: number,
        eLynxObject: IeLynxObject,
        offline: boolean,
        duration: DurationOptionEnum | undefined,
        startTime: Date | undefined,
        endTime: Date | undefined
    ) => [
            ...keys.lists(),
            {
                customerID,
                groupID,
                eLynxObject,
                offline,
                duration,
                startTime,
                endTime
            }
        ],
    // memoAutoTexts: () => [
    //     ...keys.all,
    //     "memoAutoText"
    // ],
    // memoAutoText: (
    //     customerID: number,
    //     groupID: number,
    //     objectType: eLynxObjectTypeEnum,
    //     offline: boolean
    // ) => [
    //         ...keys.memoAutoTexts(),
    //         {
    //             customerID,
    //             groupID,
    //             objectType,
    //             offline
    //         }
    // ],
    rulesEngineRules: () => [
        ...keys.all,
        "rules"
    ],
    rulesEngineRule: (
        ruleID?: number,
        ruleType?: RulesEngineRuleTypeEnum,
        runType?: RulesEngineRuleRunTypeEnum
    ) => [
        ...keys.rulesEngineRules(),
        {
            ruleID,
            ruleType,
            runType
        }
    ]
};
